"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendPostBack;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendPostBack() {
  return (0, _useWebChatAPIContext.default)().sendPostBack;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kUG9zdEJhY2sudHMiXSwibmFtZXMiOlsidXNlU2VuZFBvc3RCYWNrIiwic2VuZFBvc3RCYWNrIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQWtEO0FBQy9ELFNBQU8scUNBQXVCQyxZQUE5QjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRQb3N0QmFjaygpOiAodmFsdWU/OiBhbnkpID0+IHZvaWQge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5zZW5kUG9zdEJhY2s7XG59XG4iXX0=